<template>
  <span
    v-if="showTip"
    :class="['errorTip', extendClass]"
  >
    {{ context }}
  </span>
</template>

<script>
import i18n from '@/utils/i18n'
export default {
  name: 'errorTip',
  data () {
    return {

    }
  },
  props: {
    context: {
      type: String,
      default: i18n.t('hotb.errorTip'),
    },
    showTip: {
      type: Boolean,
      default: true,
    },
    extendClass: {
      type: String,
      default: '',
    },
  },
}
</script>

<style>
.errorTip {
  position: absolute;
  height: 30px;
  left: 0;
  line-height: 30px;
  padding: 2px 10px 2px 10px;
  background: #fefefe;
  font-family: Verdana;
  font-size: 12px;
  text-align: left;
  color: #000000;
  box-shadow: 0 5px 30px rgba(0, 0, 0, 0.4);
  font-weight: normal;
  z-index: 100;
}
.errorTip::before {
  content: '';
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid white;
  display: inline-block;
  margin-left: 5px;
  top: -5px;
  position: absolute;
}

</style>
